import { isQuestion } from "../../../../../../components/Questionnaire/Section/Question/types";
import type { VisibilityMap } from "../../../../../../components/Questionnaire/validation/form/types";
import type { Answers, QuestionnaireState } from "../../../../types";

type ApplyAddressLookupUpdatesArgs = {
  groupNames: string[];
  answers: Answers;
  visibility: VisibilityMap;
  serverVisibleByName: Record<string, boolean>;
  state: QuestionnaireState;
};

export const applyAddressLookupUpdates = ({
  groupNames,
  answers,
  visibility,
  serverVisibleByName,
  state,
}: ApplyAddressLookupUpdatesArgs): {
  answers: Answers;
  visibility: VisibilityMap;
} => {
  const nextAnswers = { ...answers };
  const nextVisibility = { ...visibility };

  const sections =
    state.mode === "stacked-sections"
      ? state.sections
      : [state.sections[state.currentSectionIndex]];

  const hiddenOnAutocompleteNames = new Set(
    sections
      .flatMap(s => s.questions)
      .filter(isQuestion)
      .filter(q => q.hiddenOnAutocomplete)
      .map(q => q.name),
  );

  groupNames.forEach(name => {
    const hasAnswer = nextAnswers[name] !== undefined;
    const visible = serverVisibleByName[name];
    nextVisibility[name] =
      hasAnswer && visible && !hiddenOnAutocompleteNames.has(name);
  });

  // We only need to handle the address group visibility here, the answers are managed in mergeAnswers
  return { answers: nextAnswers, visibility: nextVisibility };
};
